const firebaseConfig = {
    apiKey: "AIzaSyDADuP6Rq4U5QeEZBK0ZjKJGN5_fcan42E",
    authDomain: "resume-builder-bd.firebaseapp.com",
    databaseURL: "https://resume-builder-bd.firebaseio.com",
    projectId: "resume-builder-bd",
    storageBucket: "resume-builder-bd.appspot.com",
    messagingSenderId: "298181225673",
    appId: "1:298181225673:web:cefeb956734213e0f5f118"
};

export default firebaseConfig;